export const commonData = {
  baseUrl: '#',
  company: {
    legalName: 'Fitify Workouts s.r.o.',
    name: 'Fitify Workouts',
    foundingDate: '2018-03-08',
    address: {
      streetAddress: 'Na Perštýně 342/1',
      addressLocality: 'Prague',
      postalCode: '110 00',
      addressCountry: 'CZ',
      country: 'Czechia',
    },
  },
  contact: {
    landingUrl: 'https://gofitify.com',
    supportEmail: 'support@gmail.com',
  },
  socialLinks: {
    instagram: 'https://www.instagram.com/nutria_apps/',
    facebook: 'https://www.facebook.com/nutria_apps',
    x: 'https://x.com/nutria_apps',
  },
  store: {
    appStore: 'https://apps.apple.com/app/id6754564298',
    playStore:
      'https://play.google.com/store/apps/details?id=com.nutria.nutrition',
  },
}
